/**
 * Storyella 品牌 - Home 页面配置
 */
import { homeCommonConfig } from './common'
import type { HomePageConfig } from './types'

/**
 * Storyella 品牌主题配置
 */
export const theme = {
  // 首页背景图
  homeBg: '/images/storyella/home-bg.webp',
  // 标签模块背景图
  tagsBg: '/images/storyella/tag-background.webp',

  // 标签按钮选中状态 (使用品牌主色)
  tagActiveBg: '#FF4774',
  tagActiveText: '#FFFFFF',

  // 标签按钮未选中状态
  tagInactiveBg: '#FFF0F3',
  tagInactiveText: '#FF4774',

  // Tab 激活状态渐变底部装饰线
  tabActiveGradient: 'linear-gradient(270deg, #F6F7F9 0%, #FF4774 95%)',
  // Tab 激活状态文字和下划线颜色
  tabActiveColor: 'linear-gradient(90deg, #FF6734 0.03%, #FF42CC 100%)',
  // sticky-header 背景渐变
  stickyHeaderBg: 'linear-gradient(180deg, #FFE4EB 0%, #FFFFFF 100%)',
  // 顶部 Banner 撑满屏宽，无底部圆角
  topBannerRadius: '0',
} as const

export const homeConfig: HomePageConfig = {
  theme,
  texts: homeCommonConfig.texts,
}
